const FORCE_REMOTE_PREFIX = /^\/(v3|pets)\//;

const LOCAL_PREFIX = /^(?:\.{0,2}\/)+/;
const FORCE_LOCAL = new Set([
  '/v3/',
  '/v3/tenant-applications',
  '/v3/tenant-applications/',
]);

/**
 * Helper function that returns `true` if a given URL should be treated as an
 * internal (local) URL redirect, or `false` if it should be treated as
 * an external (remote) redirect
 */
export function isLocalUrl(href: string) {
  const qIndex = href.indexOf('?');

  // strips querystring if present
  const stripped = href.substring(0, qIndex >= 0 ? qIndex : href.length);

  // urls that we know should always be treated as local
  if (FORCE_LOCAL.has(stripped)) return true;

  // urls that we know should always be treated as remote
  if (FORCE_REMOTE_PREFIX.test(stripped)) return false;

  // catch-all non-local and/or malformed urls
  const [localPrefix] = stripped.match(LOCAL_PREFIX) ?? [];
  if (localPrefix === undefined || localPrefix.includes('//')) return false;

  // if we got here means urls are local and well formed
  return true;
}
